import { render, staticRenderFns } from "./CurrentSaleQty.vue?vue&type=template&id=38b60308&scoped=true"
import script from "./CurrentSaleQty.vue?vue&type=script&lang=js"
export * from "./CurrentSaleQty.vue?vue&type=script&lang=js"
import style0 from "./CurrentSaleQty.vue?vue&type=style&index=0&id=38b60308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b60308",
  null
  
)

export default component.exports